<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
    summaryColumn: Array,
    summaryRow: Array,
    pagination: Object,
});

const emit = defineEmits(['update:pagination']);

const onPaginationUpdate = (pagination) => {
    emit('update:pagination', pagination);
};
</script>

<template>
    <div class="bg-white p-6 rounded-lg border border-gray-200">
        <div class="flex justify-between items-center mb-4">
            <h4 class="text-lg font-semibold text-gray-800">Payment Summary by Gameweek</h4>
            <button
                class="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none">
                <q-icon name="download" class="mr-1" size="18px" />Export Report
            </button>
        </div>
        <div class="overflow-x-auto">
            <q-table :rows="summaryRow" :columns="summaryColumn" row-key="gameweek" class="my-sticky-header-table" flat
                bordered binary-state-sort :pagination="pagination" @update:pagination="onPaginationUpdate">
                <template v-slot:header="props">
                    <q-tr :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props" class="!text-[16px]">
                            {{ col.label }}
                        </q-th>
                    </q-tr>
                </template>
                <template v-slot:body-cell-gameweek="props">
                    <q-td :props="props">
                        <span class="text-[15px] font-medium">
                            {{ props.row.gameweek }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-totalEntries="props">
                    <q-td :props="props">
                        <span class="text-[14px] font-medium">
                            {{ props.row.totalEntries }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-paidEntries="props">
                    <q-td :props="props">
                        <span class="px-2.5 py-1 rounded-full text-[14px] font-medium text-[#059669] bg-green-200">
                            {{ props.row.paidEntries }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-postalEntries="props">
                    <q-td :props="props">
                        <span class="px-2.5 py-1 rounded-full text-[14px] font-medium text-[#2563eb] bg-blue-200">
                            {{ props.row.postalEntries }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-stripeRevenue="props">
                    <q-td :props="props">
                        <span class="text-[16px] font-medium text-[#059669]">
                            {{ props.row.stripeRevenue }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-failedPayments="props">
                    <q-td :props="props">
                        <span class="px-2.5 py-1 rounded-full text-[14px] font-medium" :class="{
                            'text-[#b05656] bg-red-200': props.row.failedPayments > 0,
                            'text-gray-300': props.row.failedPayments === 0
                        }">
                            {{ props.row.failedPayments }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-successRate="props">
                    <q-td :props="props">
                        <div class="flex items-center justify-center gap-2">
                            <!-- Container with fixed width -->
                            <div class="bg-gray-200 rounded-full h-2 w-24 overflow-hidden">
                                <div class="h-full bg-green-500" :style="{ width: `${props.row.successRate}%` }"></div>
                            </div>
                            <span class="text-xs font-medium">{{ props.row.successRate }}%</span>
                        </div>
                    </q-td>

                </template>
            </q-table>
        </div>
    </div>
</template>